import React from 'react';
import t from 'utils/translationHelper';
import useActionDropdown from 'hooks/useActionDropDown';
import { PaymentDto, PaymentVopMatchStatus } from '@alpha/payments-dtos';
import MenuDropdownItem from '@alpha/ui-lib/ui/atoms/MenuDropdownItem/MenuDropdownItem';
import APMenu from '@alpha/ui-lib/ui/molecules/Menu/Menu';
import { faEllipsisH, faTrash } from '@fortawesome/pro-regular-svg-icons';
import { ClickAwayListener } from '@alpha/ui-lib/ui/external';
import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';

interface IProps {
  payment: PaymentDto;
  setSelectedPayment: (payment: PaymentDto) => void;
  setDeletePayment: (payment: PaymentDto) => void;
}

const ValidPaymentsVOPDropdown = ({
  payment,
  setSelectedPayment,
  setDeletePayment,
}: IProps) => {
  const { open, menuCloseCount, setMenuCloseCount, setOpen } =
    useActionDropdown();
  let menuItems = [
    {
      content: <div>{t('vop_review_verification')}</div>,
      disableHoverEffect: true,
      onClick: () => {
        setSelectedPayment(payment);
      },
      arrow: false,
      icon: faMagnifyingGlass,
      key: 'vop_review_verification',
      underline: false,
    },
    {
      content: <div>{t('vop_delete_payment')}</div>,
      disableHoverEffect: true,
      icon: faTrash,
      arrow: false,
      onClick: () => {
        setDeletePayment(payment);
      },
      key: 'vop_delete_payment',
      underline: false,
    },
  ];

  if (
    payment.vopDetails?.vopApprovalAcknowledged || !payment.vopRequired
  ) {
    menuItems = menuItems.filter(
      (item) => item.key != 'vop_review_verification'
    );
  }

  const handleClickAway = (): void => {
    if (menuCloseCount === 1) {
      setMenuCloseCount(menuCloseCount + 1);
    }
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <APMenu
        open={Boolean(open)}
        setOpen={setOpen}
        anchorEl={open}
        disableBackdropClick={menuCloseCount === 1}
        disableHoverEffect
        buttonProps={{
          style: {
            height: 30,
            width: 30,
            minWidth: 0,
            backgroundColor: 'transparent',
          },
        }}
        buttonTitle=''
        // @ts-ignore
        icon={faEllipsisH}
      >
        {menuItems.map((item) => (
          <MenuDropdownItem setOpen={setOpen} key={item.key}>
            {item}
          </MenuDropdownItem>
        ))}
      </APMenu>
    </ClickAwayListener>
  );
};

export default ValidPaymentsVOPDropdown;
